import { render, staticRenderFns } from "./MaxAdmin.vue?vue&type=template&id=37574770&scoped=true&"
import script from "./MaxAdmin.vue?vue&type=script&lang=js&"
export * from "./MaxAdmin.vue?vue&type=script&lang=js&"
import style0 from "./MaxAdmin.vue?vue&type=style&index=0&id=37574770&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37574770",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/pawan/Vizmo/Max/dashboard-old/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContent } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListGroup } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VNavigationDrawer } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarSideIcon } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle,VContent,VDivider,VIcon,VList,VListGroup,VListTile,VListTileAction,VListTileContent,VListTileTitle,VMenu,VNavigationDrawer,VSpacer,VToolbar,VToolbarSideIcon,VToolbarTitle})
